import axios from 'axios';
import { matchBackend } from '@lendica/utils';
import { setAxiosInterceptors, setAxiosBaseUrl } from '@lendica/auth';

// export const env = getEnvFromHost(window.location.hostname);
export const env = process.env.REACT_APP_ENV || 'idev';

export const baseURL = matchBackend();

axios.defaults.baseURL = baseURL;

setAxiosBaseUrl(baseURL);

setAxiosInterceptors(baseURL, undefined, () => {
    window.location.replace(`${window.location.origin}/auth`);
});

export function clearActiveCompanySelection() {
    try {
        localStorage.removeItem('activeCompanyId');
    } catch {}
}

const v2BaseURL = matchBackend('v2');

axios.interceptors.response.use(
    resp => resp,
    err => {
        const status = err?.response?.status;
        const url: string = err?.config?.url || '';
        if (status === 403 && url.startsWith(v2BaseURL)) {
            clearActiveCompanySelection();
        }
        return Promise.reject(err);
    }
);
